import React from 'react'

const Oscilloscopes = () => {
    return (
        <>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Rohde & Schwarz</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Oscilloscopes </span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div>
                    <h1 className='text-center ' style={{ textDecoration: "underline" }}>Oscilloscopes</h1>
                </div>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/Oscilloscopes.png' width={400} ></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>R&S®RTC, RTB, RTM,RTA, MXO, RT Series:</h2>
                        <p class="mbot25">
                            <ul>
                                <li>Bandwidth: 50 MHz - 16 GHz</li>
                                <li>Channels: 2, 4, 8</li>
                                <li>Sample Rate: 2 Gsample/s to 40 Gsample/s</li>
                                <li>Max. Memory depth: 2 Mpts to 2 Gpts</li>
                                <li>Optional MSO: 8 digital channels to 16 digital channels</li>
                            </ul>
                        </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Oscilloscopes
